import { render, staticRenderFns } from "./deviceLicenseDetail.vue?vue&type=template&id=053df1c8&scoped=true"
import script from "./deviceLicenseDetail.vue?vue&type=script&lang=js"
export * from "./deviceLicenseDetail.vue?vue&type=script&lang=js"
import style0 from "./deviceLicenseDetail.vue?vue&type=style&index=0&id=053df1c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053df1c8",
  null
  
)

export default component.exports